class Timer {
	constructor(cbk){
		this.callback = cbk;
		this._timer = null;
	}

	start(to){
		if (this._timer){
			clearTimeout(this._timer);
		}

		this._timer = setTimeout(() => {
			this._timer = null;
			this.callback();
		}, to);
	}

	stop(){
		if (this._timer){
			clearTimeout(this._timer);
			this._timer = null;
		}
	}

	isStarted(){
		return this._timer !== null;
	}
}

module.exports = Timer;
